jQuery(function ($) {
  var arrowLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 28 30"><g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2"><path d="M27.806 14.27H2.311M16.444 29L2 14.29 16.444 1"/></g></svg>';
  var arrowRight = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"><g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2"><path d="M.213 14.162h25.763M13 1l13 13.113L13 27"/></g></svg>';


  // SLIDER
  $('[js-instructors-slider]').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true
  });

  $('[js-intro-slider]').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true
  })

  var _heroSlider = $('[js-hero-slider]');


  _heroSlider.on('init reInit', function(event, slick) {
    if(slick.slideCount > 1) {
      $('#currSlideInd').text('1');
      $('#totalSlides').text(slick.slideCount);
    } else {
      document.getElementById('slideCounter').remove();
    }

    // Unset inline display css declaration so it can have display flex from stylesheet 
    $('.section__hero .slick-slide').find('.lp-hero__slide').css('display', '');
  });

  _heroSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $('#currSlideInd').text(i);
    $('#totalSlides').text(slick.slideCount);

    const currentSlideItem = $('.section__hero .slick-slide[data-slick-index="'+currentSlide+'"]');
    $('.section__hero .slick-slide').not(currentSlideItem).find('.lp-hero__slide').removeClass('in-viewport');
    currentSlideItem.addClass('traina-current');
  });

  _heroSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    const currentSlideItem = $('.section__hero .slick-slide[data-slick-index="'+currentSlide+'"]');
    $('.section__hero .slick-slide').not(currentSlideItem).find('.lp-hero__slide').addClass('in-viewport');
  });

  _heroSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight:true,
    prevArrow:'<div class="slick-prev">'+arrowLeft+'</div>',
    nextArrow:'<div class="slick-next">'+arrowRight+'</div>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots:true,
        }
      }
    ]
  });




    /* COUNTER

    REF: https://stackoverflow.com/questions/25847297/slick-js-get-current-and-total-slides-ie-3-5

    var $status = $('.pagingInfo');
    var $slickElement = $('.slideshow');


    $slickElement.slick({
    autoplay: true,
    dots: true
  });

  */

  $('[js-slider]').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true
  });


  $('[js-blog-events-feed]').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    arrows: true
  });


  var recipeSlider = $('.slider-recipes');
  recipeSlider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots:false,
    prevArrow:'<div class="slick-prev">'+arrowLeft+'</div>',
    nextArrow:'<div class="slick-next">'+arrowRight+'</div>',
    responsive: [
      {
        breakpoint: 1750,
        settings: {
          slidesToShow:2,
        }
      },
      {
        breakpoint: 1180,
        settings: {
          slidesToShow:1,
        }
      },
      {
        breakpoint: 991,
        settings: {
          arrows:false,
          slidesToShow:1,
        }
      }
    ],
    afterChange: function(event, slick, currentSlide, nextSlide){
      var newSlide = $('.slider-recipes .slide').eq(nextSlide);
      $(newSlide).addClass('in-viewport');
    },
    beforeChange:function(event, slick, currentSlide, nextSlide){
      $('.slider-recipes').find('[data-scroll]').removeAttr('data-scroll');1
      $('.slider-recipes .slick-slide').not('.slick-current').find('.slide.in-viewport').removeClass('in-viewport');
    }
  });


  var timelineSlider = $('.timeline__slider');
  timelineSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight:false,
    autoplay: false,
    dots:true,
    infinite: false,
    customPaging: function(slick,index) {
      var slideYear = slick.$slides.eq(index).find('.timeline__slide').attr('data-year') || '';
      return '<span>' + slideYear + '</span>';
    },
    dotsClass : 'container slick-dots main-dots headline-dots pad-sm',
    appendArrows: '.timeline__navigation .prev-next-wrap',
    prevArrow:'<a href="#" class="prev btn__theme__lrg">'+arrowLeft+'</div>',
    nextArrow:'<a href="#" class="next btn__theme__lrg">'+arrowRight+'</div>',
  });

  // Set each slide's content to be equal height, and place pagination beneath it.
  // var timelinePagination = $(timelineSlider).find('.slick-dots').html();
  // $(timelineSlider).find('.timeline__slide').not('.timeline__first_slide').append('<ul class="container slick-dots"role="tablist"></ul>').find('.slick-dots').append(timelinePagination);


  timelineSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    // check which slide we're on, to display the correct buttons
    if(nextSlide === 0){
      $(timelineSlider).addClass('first-slide-active');
    } else {
      $(timelineSlider).removeClass('first-slide-active');
    }

    // Add class to new slide to animate content
    var newSlide = $(timelineSlider).find('.timeline__slide').eq(nextSlide);

    $(newSlide).addClass('in-viewport');

    // Make sure pagination doesn't cover slide contentTop
    timelinePagination(newSlide);
  });

  timelineSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
    $(timelineSlider).find('.slick-slide').not('.slick-current').find('.timeline__slide.in-viewport').removeClass('in-viewport');

    var currentSlide = $(timelineSlider).find('.slick-slide').eq(currentSlide);
  });

  timelineSlider.on('init', function(){
    timelinePagination();
  });

  $('.timeline__outer .first-slide-nav').on('click', function(e){
    e.preventDefault();
    $(timelineSlider).slick('slickGoTo', 1, false);
  });

  // Timeline Pagination function
  function timelinePagination() {
    if($(timelineSlider).length){
      setTimeout(function(){
        var parent = $('.timeline__slider');
        var pagination = $(parent).find('.slick-dots.main-dots');
        var currentSlide = $(parent).find('.slick-current');
        // Don't position elements if on the first slide of the timeline
        if(!$(currentSlide).is(':first-child')){
          var content = $(currentSlide).find('.timeline__content');
          if(!content.length){
            content = $(parent).find('.slick-slide:first-child .timeline__content');
          }
          var contentTop = $(content).position().top;
          var contentBottom = $(content).outerHeight() + contentTop + 40;

          $(pagination).css({top: contentBottom});

          // add back to start button
          if(!$(parent).find('.back-to-start').length){
            $(pagination).parent().append('<div class="container back-to-start"><a href="#">'+arrowLeft+' Back to Start</a></div>');
          }
          var backToStart = $(parent).find('.back-to-start');
          var backToStartPos = contentTop - 40 - $(backToStart).outerHeight();
          $(backToStart).css({top: backToStartPos});
        }
      }, 100);
    }
  }
  timelinePagination();


  $('body').on('click', '.timeline__slider .back-to-start a', function(e){
    e.preventDefault();
    $(timelineSlider).slick('slickGoTo', 0, false);
  });

  // used for window resize functions to reduce function calls
  function debouncer( func , timeout ) {
    var timeoutID , timeout = timeout || 20;
    return function () {
      var scope = this , args = arguments;
      clearTimeout( timeoutID );
      timeoutID = setTimeout( function () {
        func.apply( scope , Array.prototype.slice.call( args ) );
      } , timeout );
    };
  }

  $( window ).resize( debouncer( function ( e ) {
    timelinePagination();
  } ) );



  // Gutenberg Slider Blocks (Gallery Slider block included)
  // Front-end Only
  $(document).ready(() => {
    // Re-Order Activist Slides
    var activistSliders = document.querySelectorAll('.activist_slider__slider');
    activistSliders.forEach(slider => {
      for (var i = slider.children.length; i >= 0; i--) {
        slider.appendChild(slider.children[Math.random() * i | 0]);
      }
    });

    // Initialize Sliders
    $('.gallery_slider, .block__gallery, .activist_slider, .social-feed-api-slider').each(function(){
      initializeBlock($(this));
    });
  });

  var initializeBlock = function( $block ) {
    // First, Determine which block we're in, and set the args accordingly.
    let slider = false;
    let args;
    var arrowLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 28 30"><g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2"><path d="M27.806 14.27H2.311M16.444 29L2 14.29 16.444 1"/></g></svg>';
    var arrowRight = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"><g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2"><path d="M.213 14.162h25.763M13 1l13 13.113L13 27"/></g></svg>';

    // Quote Slider Block
    if($block.find('.gallery-slider').length){
      slider = $block.find('.gallery-slider');
      var appendNav = slider.next('.gallery-slider-nav');
      args = {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight:false,
        autoplay: false,
        dots:false,
        appendArrows: appendNav,
        prevArrow:'<a href="#" class="prev btn__theme__lrg">'+arrowLeft+'</div>',
        nextArrow:'<a href="#" class="next btn__theme__lrg">'+arrowRight+'</div>',
      }

      $('body').on('click', '.gallery-slider-nav a', function(){
        $(this).blur();
      });
    }

    // Activist Slider
    if($block.find('.activist_slider__slider').length){
      slider = $block.find('.activist_slider__slider');

      var appendNav = slider.next('.gallery-slider-nav');
      args = {
        slidesToShow: 5,
        slidesToScroll: 5,
        adaptiveHeight:false,
        autoplay: false,
        dots:false,
        appendArrows: appendNav,
        prevArrow:'<a href="#" class="prev btn__theme__lrg">'+arrowLeft+'</div>',
        nextArrow:'<a href="#" class="next btn__theme__lrg">'+arrowRight+'</div>',
        responsive: [
          {
            breakpoint: 1670,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }

    // Social Feed Slider
    if($block.find('.social-feed-slider').length){
      slider = $block.find('.social-feed-slider');

      var arrowLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 28 30"><g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2"><path d="M27.806 14.27H2.311M16.444 29L2 14.29 16.444 1"/></g></svg>';
      var arrowRight = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"><g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2"><path d="M.213 14.162h25.763M13 1l13 13.113L13 27"/></g></svg>';
      $block.addClass('controls-left');

      args = {
        slidesToShow: 4,
        // slide: 'a',
        slidesToScroll: 1,
        arrows: true,
        dots:false,
        prevArrow:'<div class="slick-prev">'+arrowLeft+'</div>',
        nextArrow:'<div class="slick-next">'+arrowRight+'</div>',
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow:3,
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow:2,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow:1,
            }
          }
        ]
      };
    }

    if(slider){
      if(slider.hasClass('slick-initialized')){
        slider.slick('unslick')
      }
      slider.slick(args);
    }
  }

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=gallery-slider', initializeBlock );
    window.acf.addAction( 'render_block_preview/type=activist-slider', initializeBlock );
    window.acf.addAction( 'render_block_preview/type=instagram-feed', initializeBlock );
  }

});
